package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project_content.design

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.styleModifier
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.borderSetting
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Floor
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.RestaurantProject
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.PaintIcon
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div


@Composable
fun RestaurantDesign(
    selectedRestaurantProject: RestaurantProject?,
    selectedRoom: Room?,
    onUpdateFurniture: (String, Int, Int, Int, Int, Int) -> Unit,
    onTransformFurniture: (String, Int, Int, Int, Int, Int,String?) -> Unit,
    onSelectNewRoom: (Room?) -> Unit,
    onFurnitureCopy: (Furniture) -> Unit,
    onFurnitureDelete: (String) -> Unit,
    onFurnitureFocus: (Furniture?) -> Unit,
)
{
    Column(
        modifier = Modifier
            .fillMaxHeight()
            .showContentInOnePage()
            .fillMaxWidth()
    )
    {

        RestaurantDesignHeaders(
            selectedRestaurantProject=selectedRestaurantProject,
            selectedRoom = selectedRoom,
            onSelectNewRoom = {
                onSelectNewRoom(it)
            }
        )

        if(selectedRoom!=null)
        {
            DesignCoordinates(
                selectedRoom=selectedRoom,
                onFurnitureFocus = {
                    onFurnitureFocus(it)
                },
                updateFurniture = { id:String, offsetX:Int,
                                    offsetY:Int, rotationDeg:Int, width:Int, height:Int->

                    onUpdateFurniture(id,offsetX,offsetY,rotationDeg,width,height)
                },
                transformFurniture = { id:String,
                                       offsetX:Int,
                                       offsetY:Int,
                                       rotationDeg:Int,
                                       width:Int,
                                       height:Int,
                                        objectKind:String?,
                                        ->

                    onTransformFurniture(id,offsetX,offsetY,rotationDeg,width,height,objectKind)
                },
                onFurnitureDelete = {
                    onFurnitureDelete(it)
                },
                onFurnitureCopy = {
                    onFurnitureCopy(it)
                }
            )


        }





    }


}



@Composable
fun DesignCoordinates(
    selectedRoom: Room?,
    updateFurniture: (String, Int, Int, Int, Int, Int) -> Unit,
    transformFurniture: (String, Int, Int, Int, Int, Int,String?) -> Unit,
    onFurnitureDelete: (String) -> Unit,
    onFurnitureCopy: (Furniture) -> Unit,
    onFurnitureFocus: (Furniture?) -> Unit,
) {
    val containerId = "konvaContainer"
    val rootRef = remember { mutableStateOf<dynamic>(null) }
    val unitSize =10
    val copyFieldName=Strings.current().copy
    val deleteFieldName=Strings.current().delete


    Box(
        modifier = Modifier
            .borderSetting()
            .padding(0.px)
            .showContentInOnePage()
            .fillMaxWidth()
            .fillMaxHeight()
            .position(Position.Relative)
            .display(DisplayStyle.Flex)
            .overflow(Overflow.Auto)
            .styleModifier {
                property("scrollbar-width", "thin")
                property("scrollbar-color",
                    Theme.ActionDisabledBackground.hex +
                            " ${Theme.ActionHover.hex}")
                property("max-width", "100%")
                property("max-height", "100%")
                property("overflow-x", "auto")
                property("overflow-y", "auto")
            }
    ) {


        Div(
            attrs = {
                id(containerId)
                style {
                    position(Position.Absolute)
                    property("top", "0")
                    property("left", "0")
                    borderRadius(Dimen.semiLargeRadius)
                    width(100.percent)
                    height(100.percent)
                    minHeight(Dimen.restaurantDesignMinHeight)
                    property("overflow", "auto")
                }
            }
        ) {

            RenderKonvaStage(
                root = rootRef.value,
                containerId=containerId,
                rootRef=rootRef,
                selectedRoom = selectedRoom,
                unitSize = unitSize,
                copyFieldName = copyFieldName,
                deleteFieldName = deleteFieldName,
                onFurnitureFocus = {
                   onFurnitureFocus(it)
                },
                updateFurniture = { furnitureId:String, x:Int, y:Int,
                                    rotation:Int, width:Int, height:Int ->
                    updateFurniture(
                        furnitureId, x, y, rotation, width, height,
                    )
                },
                transformFurniture = {furnitureId:String, x:Int, y:Int,
                                      rotation:Int, width:Int, height:Int,objectKind ->
                    transformFurniture(furnitureId, x, y, rotation, width, height,objectKind)
                },
                onFurnitureCopy = {
                    onFurnitureCopy(it)
                },
                onFurnitureDelete = {
                    onFurnitureDelete(it)
                }
            )
        }
    }
}




@Composable
private fun RestaurantDesignHeaders(
    selectedRestaurantProject: RestaurantProject?,
    selectedRoom: Room?,
    onSelectNewRoom:(Room?)->Unit,
) {

    val roomList= remember { mutableStateOf<List<Room?>?>(null)}

    LaunchedEffect(selectedRoom){
        roomList.value= selectedRestaurantProject?.floors?.filter {
            it?.id==selectedRoom?.floorId
        }?.getOrNull(0)?.rooms
    }


    Row(
        modifier = Modifier,
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        DropDownItem(
            modifier = Modifier
                .margin(
                    right = Dimen.normalPadding,
                    bottom = Dimen.normalPadding,
                ),
            itemWidth = Dimen.highNormalEditTextWidth,
            options =selectedRestaurantProject?.floors
                ?: listOf(),
            label = "",
            selectedItem = selectedRestaurantProject?.floors?.filter {
                it?.id==selectedRoom?.floorId
            }?.getOrNull(0),
            displayText = {
                if (it is Floor?)
                    "${it.typename} ${it.number}" else ""
            },
            onOptionClick = {
                if (it is Floor?){
                    roomList.value=it?.rooms
                    onSelectNewRoom(roomList.value?.getOrNull(0))
                }


            }
        )

        DropDownItem(
            modifier = Modifier
                .margin(
                    leftRight = Dimen.normalPadding,
                    bottom = Dimen.normalPadding,
                ),
            itemWidth = Dimen.highNormalEditTextWidth,
            options = roomList.value?: listOf(),
            label = "",
            selectedItem =selectedRoom,
            displayText = {
                if (it is Room)
                    it.caption?:"" else ""
            },
            onOptionClick = {
                if (it is Room){
                    onSelectNewRoom(it)
                }
            }
        )


        PaintIcon(
            modifier =Modifier
                .margin(leftRight = Dimen.normalPadding) ,
            selectedColor = selectedRoom?.roomColor,
            onPaintIconClick = {

            }
        )



        CustomButton(
            modifier = Modifier
                .margin(
                    left = Dimen.normalPadding,
                ),
            title = Strings.current().show3D,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {},
        )


    }
}

